import React, { Component, createContext } from "react";
import { auth } from "../config.tsx";


export const UserContext = createContext({ user: null });
class UserProvider extends Component {
  state = {
    user: null
  };

  async componentWillMount() {
    await auth.onAuthStateChanged(usera => {
      this.setState({ user: usera});
    });
  };
  render() {
    return (
      <UserContext.Provider value={this.state.user}>
        {this.props.children}
      </UserContext.Provider>
    );
  }
}
export default UserProvider;